export default "__VITE_ASSET__d7O$$tMWJglmFJ$YAOFaLg__"